<template>
  <div id="ticket-container-id" class="ticket-container">
    <paginaRingraziamento
      v-if="showPaginaRingraziamento"
      :paginaRingraziamentoLogId="paginaRingraziamentoLogId"
      :setPaginaLoaderCallback="setPaginaLoaderCallback"
      :ticketId="ticketIdCreato"
    >
    </paginaRingraziamento>
    <form
      v-if="showTicketForm && !showErrorAlert"
      class="row g-3 needs-validation text-start"
      @submit="checkForm"
      :novalidate="novalidate"
    >
      <div class="titolo-form-ticket-container">
        <h1>Compila i campi sottostanti in modo da essere ricontattato:</h1>
      </div>
      <ticketFormInputs
        ref="ticketFormInputs"
        :answerDetail="answerDetail"
      ></ticketFormInputs>
      <fileUploaderList
        ref="fileListUploader"
        :answerDetail="answerDetail"
        :ticketId="ticketIdCreato"
      />
      <div class="col-12 fw-bold">
        {{ intl[$store.state.lang]["privacy"] }}
        <span style="font-weight: bold">
          <a target="_blank" style="color: #008c95" :href="tocUrl"
            >Privacy</a
          ></span
        ><span style="font-weight: bold">*:</span>
      </div>
      <div class="col-12">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="validationToc"
            aria-describedby="invalidToc"
            v-model="toc"
            required
          />
          <label class="form-check-label" for="validationToc" v-html="terms">
          </label>
          <div id="invalidToc" class="invalid-feedback">
            {{ intl[$store.state.lang]["terms-and-conditions-not-ok"] }}
          </div>
        </div>
      </div>

      <!-- <div id="dynamic_recaptcha_1" class="g-recaptcha" data-sitekey="6Lf9ZRUTAAAAACEhXSnlIrYUm5Uaq4sdyL27TKUp" data-theme="light" data-size="normal"></div> -->
      <div id="recaptcha" ref="recaptcha"></div>
      <span
        v-if="recaptchaError"
        style="font-size: 14px; margin-top: 10px; color: red"
      >
        Per favore spunta il controllo reCaptcha
      </span>

      <div class="col-12">
        <button
          class="btn btn-primary"
          :disabled="!this.toc"
          type="submit"
          style="
            background-color: #008c95;
            border-color: #008c95;
            background-image: unset;
          "
        >
          {{ intl[$store.state.lang]["submit-request"] }}
        </button>
      </div>
      <span style="font-size: 14px; margin-top: 10px">
        {{ intl[$store.state.lang]["required-fields"] }}</span
      >
    </form>
    <div
      v-if="showErrorAlert"
      class="alert alert-danger mt-5"
      role="alert"
      style="font-size: 16px"
    >
      Si è verificato un errore durante la creazione del ticket. Si prega di riprovare più
      tardi.
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import { apiUrls } from "../../api/apiUrls";
import axios from "axios";
import { getManualInputOrder } from "../ticketFormInputs/utils";
import { MD5 } from "crypto-js";
import PaginaRingraziamento from "../paginaRingraziamento/PaginaRingraziamento.vue";
import TicketFormInputs from "../ticketFormInputs/TicketFormInputs.vue";
import FileUploaderList from "../fileUploaderList/FileUploaderList.vue";
export default {
  name: "ticket",
  components: {
    paginaRingraziamento: PaginaRingraziamento,
    ticketFormInputs: TicketFormInputs,
    fileUploaderList: FileUploaderList,
  },

  props: {
    surveyId: {
      type: Number,
      default: null,
    },
    answerId: {
      type: Number,
      default: null,
    },
    getPaginaRingraziamentoCallback: {
      type: Function,
      default: (value) => {
        console.log("Pagina ringraziamento show: ", value);
      },
    },
    includiPaginaRingraziamento: {
      type: Boolean,
      default: true,
    },
    novalidate: {
      type: Boolean,
      default: true,
    },
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        return;
      },
    },
    onCreateTicketCallback: {
      type: Function,
      default: (response) => {
        //console.log("Info ticket creato: ", response);
        return;
      },
    },
    staticAnswerShowInput: {
      type: Boolean,
      default: false,
    },
    staticAnswerShowInputElements: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    if (this.$store.state.libraryWiperConfig.tocUrl) {
      this.tocUrl = this.$store.state.libraryWiperConfig.tocUrl;
    }
    this.addFormEventListener();
    this.getAnswerDetail();

    this.recaptchaWidgetId = grecaptcha.render(this.$refs.recaptcha, {
      sitekey: this.siteKey,
      callback: this.recaptchaCallback,
    });
  },
  beforeUnmount() {
    this.removeFormEventListener();
  },
  data: function () {
    return {
      intl: intl,
      toc: false,
      ticketLoader: false,
      showErrorAlert: false,
      ticketIdCreato: null,
      paginaRingraziamentoLogId: null,
      answerDetail: null,
      recaptchaWidgetId: null,
      siteKey: "6Lf9ZRUTAAAAACEhXSnlIrYUm5Uaq4sdyL27TKUp",
      tocUrl:
        "https://www.organismo-am.it/documenti/OAM-Informativa_di_base.pdf",
      terms:
        "Autorizzo il trattamento dei miei dati personali ai sensi del D.Lgs. 196/2003 e all’art. 13 GDPR 679/16.",
      recaptchaError: false,
    };
  },
  methods: {
    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },

    recaptchaCallback(response) {
      if (response && this.recaptchaError === true) {
        this.recaptchaError = false;
      }
      return;
    },

      prepareDefaultPayload(inputParams){
      const fd = new FormData();
      let id_survey = this.$store.getters.getSurveyLogId;
      let area = 2
      let activation_code = MD5(inputParams['name'] + ':' + inputParams['telefon'] + ':' + id_survey).toString()
   /*    if (this.answerDetail?.answerAreaAsoc[0]?.id_area) {
        area =  this.answerDetail?.answerAreaAsoc[0]?.id_area;
      } */
      if (!inputParams["email"] && inputParams["pec"]) {
          inputParams["email"] = inputParams["pec"];
          inputParams["pec_peo"] = 0;
      } else if (inputParams["email"]) {
        inputParams["pec_peo"] = 1;
      }
      for (const key in inputParams) {
        if (inputParams.hasOwnProperty(key)) {
          fd.append(key, inputParams[key]);
        }
      }
      fd.append("area", area);
      fd.append("status", 0);
      fd.append("survey_ok", "0");
      fd.append("active", '1');
      fd.append("id_survey", id_survey);
      const params = new URLSearchParams(window.location.search);
      const isGeam = params.get('isGeam');
      if(this.$store.state["libraryWiperConfig"].startFromAnswerId && isGeam == 'true'){
        fd.append("from_siav", 1);
      }
      this.addAttachmentsToFormData(fd)
      return fd


    },
    addAttachmentsToFormData(fd){

        if (this.$refs.fileListUploader?.getFilesAndTypes) {
          let fileAndTypes = this.$refs.fileListUploader.getFilesAndTypes();
          if (fileAndTypes?.length > 0) {
            this.addFileAndTypesToFormdata(fd, fileAndTypes);
          }
        }
      
    },

    addFileAndTypesToFormdata(fd, fileAndTypes) {
      fileAndTypes.map((f) => {
        if (f.file && f.type) {
          fd.append("file[]", f.file);
          fd.append("type[]", f.type);
        }
      });
    },

    async checkForm(e) {
      if (e) e.preventDefault();
      this.recaptchaError = false;
      this.showErrorAlert = false;
      const responseCaptcha = await grecaptcha.getResponse(
        this.recaptchaWidgetId
      );


      this.$refs.fileListUploader &&
        this.$refs.fileListUploader.checkAttachmentsOnCreateTicket();
      this.$refs["ticketFormInputs"] &&
        this.$refs["ticketFormInputs"].checkFormInputsMessages();
      if (responseCaptcha.length === 0) {
        this.recaptchaError = true;
      }

      if (
        this.$store.getters.getSurveyLogId &&
        this.toc &&
        this.$refs["ticketFormInputs"].inputOblligatoriOk() &&
        this.$refs.fileListUploader.fileObbligatoriDaCaricare().length === 0 &&
        !this.$refs.fileListUploader.esisteUnFileNonCoerente() &&
        !this.recaptchaError
      ) {

        this.ticketLoader = true;
        let inputParams = this.$refs["ticketFormInputs"].getInputParams();
        let formData = this.prepareDefaultPayload(inputParams);

        this.paginaRingraziamentoLogId =  this.$store.getters.getSurveyLogId;

        await axios
          .post(apiUrls["create_ticket"], formData)
          .then(async (response) => {
            if (response.data) {
              this.onCreateTicketCallback(response);
            }
            let newTicketId= response.data.id;

          
            this.ticketLoader = false;
            this.ticketIdCreato = newTicketId;
            this.$store.dispatch("DELETE_SURVEY_LOG");

            if (this.$store.hasModule("questionarioStore-" + this.surveyId)) {
              this.$store.commit(
                "questionarioStore-" + this.surveyId + "/doCloseQuiz"
              );
            }
          })
          .catch((error) => {
            this.ticketLoader = false;
            
            this.$store.dispatch("SHOW_ERRORE_GENERICO");

          });
      } else {
        if (this.$store.state.libraryWiperConfig.scrollOnTicketForm === "true") {
          const element = document.getElementById("ticket-container-id");
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }
    },
    addFormEventListener() {
      var forms = document.querySelectorAll(
        ".ticket-container .needs-validation"
      );
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            } else {
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    getAnswerDetail() {
      if (this.answerId) {
        this.ticketLoader = true;

        axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {
            if (response.data) {
              let manualOrder = getManualInputOrder();
              this.answerDetail = response.data;
              if (this.answerDetail?.answerShowInput?.length > 0) {
                this.answerDetail.answerShowInput.map((element, i) => {
                  if (
                    element["name"] &&
                    element["name"].startsWith("faqhelp_")
                  ) {
                    if (element["name"] === "faqhelp_email") {
                      element["name"] = "pec_or_peo_email";
                    } else if (element["name"] === "faqhelp_phone_mobile") {
                      element["name"] = "telefon";
                    } else {
                      element["name"] = element["name"].replace("faqhelp_", "");
                    }
                  }
                });
                this.answerDetail.answerShowInput.push({
                  name: "question",
                  required: 1,
                });
                this.answerDetail.answerShowInput.sort(
                  (a, b) => manualOrder[a.name] - manualOrder[b.name]
                );
              }
            }

            this.ticketLoader = false;
          })
          .catch((error) => {
            this.ticketLoader = false;
          });
      }
    },
    removeFormEventListener() {
      var forms = document.querySelectorAll(
        ".ticket-container .needs-validation"
      );
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.removeEventListener(
          "submit",
          function (event) {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }

            form.classList.add("was-validated");
          },
          false
        );
      });
    },
  },
  watch: {
    ticketLoader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ ticketLoader: newValue });
        }
      },
      deep: true,
    },
  },
  computed: {
    showPaginaRingraziamento: function () {
      this.getPaginaRingraziamentoCallback(
        this.includiPaginaRingraziamento && this.ticketIdCreato !== null
      );
      return this.includiPaginaRingraziamento && this.ticketIdCreato !== null;
    },
    showTicketForm: function () {
      return (
        !this.includiPaginaRingraziamento ||
        (this.includiPaginaRingraziamento && this.ticketIdCreato === null)
      );
    },
  },
};
</script>
